import { render, staticRenderFns } from "./svg-caret-down.vue?vue&type=template&id=831b6166&"
import script from "./svg-caret-down.vue?vue&type=script&lang=js&"
export * from "./svg-caret-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports